/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Victor Manuel Calle Londoño                                ║
║ victor.calle@est.iudigital.edu.co                          ║
╚════════════════════════════════════════════════════════════╝
*/
import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Icon,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Typography,
  TextField,
  styled,
  Button,
  Card,
  FormHelperText,
} from "@mui/material";
import colors from "assets/theme/base/colors";
import closeImg from "assets/images/close_X.svg";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";

export function CardTypeEdit({
  open,
  dataTypeCard,
  objectExpired,
  handleClose,
  isFormModified,
  isDisabled,
  getFieldValue,
  name,
  handleFieldChange,
  handleSubmit,
  isFieldValid,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "700px",
    borderRadius: "20px",
    boxShadow: 24,
    p: 4,
    maxHeight: "95vh",
  };

  const content = {
    margin: "0",
    padding: "0",
    display: "grid",
    width: "100%",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
    justifyItems: "center", // Centra horizontalmente los elementos hijos
    alignItems: "center", // Centra verticalmente los elementos hijos
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <MDBox
          mt={-7}
          color="white"
          bgColor="info"
          variant="gradient"
          borderRadius="lg"
          p={2}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          {isDisabled === true ? (
            <Typography id="modal-modal-title" component="h2">
              Viendo tipo de carnet: {name}
            </Typography>
          ) : (
            <Typography id="modal-modal-title" component="h2">
              Editando tipo de carnet: {name}
            </Typography>
          )}
          <Icon
            sx={{
              fontSize: "2em",
              stroke: "currentColor",
              strokeWidth: "2px",
              cursor: "pointer",
              marginLeft: "auto",
            }}
            onClick={handleClose}
          >
            close
          </Icon>
        </MDBox>
        <Divider variant="middle" />

        <form onSubmit={handleSubmit}>
          <div style={{ maxHeight: "80%", overflowY: "auto" }}>
            <Box sx={content}>
              <Box>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Tipo de carnet
                </Typography>
                <MDInput
                  disabled={isDisabled}
                  style={{ marginTop: "5px" }}
                  value={getFieldValue("name")}
                  error={!isFieldValid.name}
                  helperText={!isFieldValid.name ? "Sin numeros ni caracteres especiales." : ""}
                  FormHelperTextProps={{ className: !isFieldValid.name ? "Mui-error" : "" }}
                  onChange={(e) => handleFieldChange("name", e.target.value)}
                />
              </Box>
              {/* <Box>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                  Fecha de expiración
                </Typography>
                <Box sx={{ marginTop: "5px", alignItems: "center" }}>
                  <MDInput
                    disabled={isDisabled}
                    style={{ width: "4.2em", marginRight: "5px" }}
                    value={getFieldValue("expiredNumber")}
                    error={!isFieldValid.expiredNumber}
                    helperText={!isFieldValid.expiredNumber ? "Ingrese un valor numerico." : ""}
                    FormHelperTextProps={{
                      className: !isFieldValid.expiredNumber ? "Mui-error" : "",
                    }}
                    onChange={(e) => {
                      handleFieldChange("expiredNumber", e.target.value);
                    }}
                  />
                  <FormControl sx={{ minWidth: 80 }} error={!isFieldValid.expiredStr}>
                    <Select
                      labelId="demo-simple-select-autowidth-label"
                      id="demo-simple-select-autowidth"
                      value={getFieldValue("expiredStr") ? getFieldValue("expiredStr") : ""}
                      onChange={(e) => handleFieldChange("expiredStr", e.target.value)}
                      style={{ fontSize: "15px", padding: "10px" }}
                      disabled={isDisabled}
                      displayEmpty
                    >
                      <MenuItem value={""}>Seleccione...</MenuItem>
                      <MenuItem value={"day"}>Día</MenuItem>
                      <MenuItem value={"month"}>Mes</MenuItem>
                    </Select>
                    {!isFieldValid.expiredStr && (
                      <FormHelperText>Tipo de fecha requerida</FormHelperText>
                    )}
                  </FormControl>
                </Box>
              </Box> */}
            </Box>
          </div>
          <Divider variant="middle" />
          <MDBox
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
            m={-0.5}
            mb={-2}
          >
            {isDisabled === true ? (
              <MDButton color="error" onClick={handleClose}>
                Cerrar
              </MDButton>
            ) : (
              <MDButton color="error" onClick={handleClose}>
                Cancelar
              </MDButton>
            )}
            {isDisabled === true ? (
              ""
            ) : (
              <MDButton
                onClick={handleSubmit}
                type="submit"
                disabled={isDisabled === true ? isDisabled : isDisabled === isFormModified}
                color="success"
              >
                Guardar
              </MDButton>
            )}
          </MDBox>
        </form>
      </Card>
    </Modal>
  );
}

CardTypeEdit.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isDisabled: PropTypes.bool,
  getFieldValue: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  isFormModified: PropTypes.bool,
};
